import {Component, NgZone, ViewChild} from '@angular/core';
import {App, Events, IonicPage, NavController, NavParams, Platform, Tabs} from 'ionic-angular';
import {AppModuleListPage} from "../app-module-list/app-module-list";
import {AppChatPage} from "../app-chat/app-chat";
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {AppMyWayPage} from "../app-my-way/app-my-way";
import {AppStatsPage} from "../app-stats/app-stats";
import {AppVideoPlusPage} from "../app-video-plus/app-video-plus";
import {Push, PushObject, PushOptions} from "@ionic-native/push";
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {SplashScreen} from "@ionic-native/splash-screen";
import {ChatStateProvider} from "../../providers/chat-state/chat-state";
import {AppStatsIntroPage} from "../app-stats-intro/app-stats-intro";
import {AppChallengeIntroPage} from "../app-challenge-intro/app-challenge-intro";
import {AppChallengeInAppPage} from "../app-challenge-in-app/app-challenge-in-app";
import {ChallengeProvider} from "../../providers/challenge/challenge";

/**
 * Generated class for the AppDashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-dashboard',
  templateUrl: 'app-dashboard.html',
})
export class AppDashboardPage {

  tab1: any = AppModuleListPage;
  tab2: any = AppChatPage;
  tab3: any = AppStatsIntroPage;
  tab4: any = AppVideoPlusPage;
  tab5: any = AppMyWayPage;
  tab6: any = AppChallengeIntroPage;

  @ViewChild('mainTabs') tabRef: Tabs;

  unreadMessages: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public userState: UserStateProvider,
    public events:Events,
    public splash: SplashScreen,
    public chatState: ChatStateProvider,
    public ngZone: NgZone,
    public platform: Platform,
    public challengeProvider: ChallengeProvider
  ) {
    this.events.subscribe('redirectToView', (params: {page: any}) => {
      if (params.page == 'challenges') {
        this.navCtrl.push(AppChallengeIntroPage)
      }
      if (params.page == 'challenge-in-app') {
        this.navCtrl.push(AppChallengeInAppPage)
      }
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppDashboardPage');

    setTimeout(() => {
      this.splash.hide();
    }, 500);

    this.events.subscribe('chat-state:unread', () => {
      this.ngZone.run(() => {
        this.unreadMessages = true;
      })
    });
    this.events.subscribe('chat-state:read', () => {
      console.log('read received');
      this.ngZone.run(() => {
        this.unreadMessages = false;
      })
    });

    this.platform.registerBackButtonAction(() => {
      console.log('back');

      let backPromise = this.app.goBack();
      if(backPromise) {
        backPromise.then().catch(console.log)
      } else {
        if(this.tabRef.getSelected().index == 0) {
          this.platform.exitApp();
        } else {
          this.tabRef.select(0);
        }
      }
    });

    setTimeout(() => {
      this.challengeProvider.unmuteChallengePopup();
    }, 5000);





  }

}



// WEBPACK FOOTER //
// ./src/pages/app-dashboard/app-dashboard.ts